import { render, staticRenderFns } from "./AppointmentDetailsParticipants.vue?vue&type=template&id=f761da3c&scoped=true"
import script from "./AppointmentDetailsParticipants.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetailsParticipants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f761da3c",
  null
  
)

export default component.exports